<template>
  <v-card width="100%">
    <management-nav />
    <v-card-title>
      Platforma ogólna - linki specjalne
      <v-spacer></v-spacer>
    </v-card-title>

    <v-row class="ml-1">
      <v-col cols="12">
        <v-row
          class="pb-0"
          style="gap: 10px"
          v-for="(packageLink, index) in packagesLinksForGeneral"
          :key="`codeValue${index}`"
        >
          <v-col cols="4">
            <v-text-field-with-validation
              v-model="packageLink.link"
              label="Link"
              color="indigo"
              outlined
              dense
            />
          </v-col>

          <v-col cols="4">
            <v-text-field-with-validation
              v-model="packageLink.name"
              label="Podpis"
              color="indigo"
              outlined
              dense
            />
          </v-col>

          <v-col cols="2">
            <div class="expirationDateColumn">
              <v-text-field
                v-model="packageLink.expirationTime"
                type="date"
                label="Data wygaśnięcia (koniec dnia)"
                color="indigo"
                outlined
                dense
                required
              />
            </div>
          </v-col>

          <v-col cols="1">
            <v-btn
              @click="removePackageLinkForGeneral(packageLink, index)"
              class="ml-2"
              fab
              x-small
              color="red"
            >
              <font-awesome-icon icon="minus" />
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="ml-1 mb-4">
      <v-col>
        <v-btn @click="addNextPackageLinkForGeneral" color="orange">
          Dodaj kolejny link
          <font-awesome-icon icon="plus" />
        </v-btn>
      </v-col>
    </v-row>

    <v-card-title>
      Platforma dla początkujących - linki specjalne
      <v-spacer></v-spacer>
    </v-card-title>

    <v-row class="ml-1">
      <v-col cols="12">
        <v-row
          class="pb-0"
          style="gap: 10px"
          v-for="(packageLink, index) in packagesLinksForBeginners"
          :key="`codeValue${index}`"
        >
          <v-col cols="4">
            <v-text-field-with-validation
              v-model="packageLink.link"
              label="Link"
              color="indigo"
              outlined
              dense
            />
          </v-col>

          <v-col cols="4">
            <v-text-field-with-validation
              v-model="packageLink.name"
              label="Podpis"
              color="indigo"
              outlined
              dense
            />
          </v-col>

          <v-col cols="2">
            <div class="expirationDateColumn">
              <v-text-field
                v-model="packageLink.expirationTime"
                type="date"
                label="Data wygaśnięcia (koniec dnia)"
                color="indigo"
                outlined
                dense
                required
              />
            </div>
          </v-col>

          <v-col cols="1">
            <v-btn
              @click="removePackageLinkForBeginners(packageLink, index)"
              class="ml-2"
              fab
              x-small
              color="red"
            >
              <font-awesome-icon icon="minus" />
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="ml-1 mb-4">
      <v-col>
        <v-btn @click="addNextPackageLinkForBeginners" color="orange">
          Dodaj kolejny link
          <font-awesome-icon icon="plus" />
        </v-btn>
      </v-col>
    </v-row>

    <v-btn class="ml-4" style="width: 100%" @click="saveLinks" color="green"
      >Zapisz</v-btn
    >
  </v-card>
</template>

<script>
import moment from "moment";
import VTextFieldWithValidation from "../components/inputs/VTextFieldWithValidation.vue";
import ManagementNav from "../components/ManagementNav.vue";
export default {
  name: "TimePackagesLinksManagement",
  components: {
    ManagementNav,
    VTextFieldWithValidation,
  },
  async created() {
    await this.$store.dispatch("timePackagesLinks/fetchTimePackagesLinks");
    this.packagesLinksForBeginners = this.timePackagesLinksForBeginners.map(
      (link) => {
        return {
          id: link.id,
          link: link.link,
          name: link.name,
          expirationTime: link.expirationTime
            ? moment(link.expirationTime).format("YYYY-MM-DD")
            : moment().format("YYYY-MM-DD"),
        };
      }
    );
    this.packagesLinksForGeneral = this.timePackagesLinksForGeneral.map(
      (link) => {
        return {
          id: link.id,
          link: link.link,
          name: link.name,
          expirationTime: link.expirationTime
            ? moment(link.expirationTime).format("YYYY-MM-DD")
            : moment().format("YYYY-MM-DD"),
        };
      }
    );
  },
  data: () => ({
    packagesLinksForBeginners: [],
    packagesLinksForGeneral: [],
    packagesLinksToRemove: [],
  }),
  computed: {
    timePackagesLinksForBeginners() {
      return this.$store.getters[
        "timePackagesLinks/getTimePackagesLinksForBeginner"
      ];
    },
    timePackagesLinksForGeneral() {
      return this.$store.getters[
        "timePackagesLinks/getTimePackagesLinksForGeneral"
      ];
    },
  },

  watch: {
    timePackagesLinksForGeneral() {
      this.packagesLinksForGeneral = this.timePackagesLinksForGeneral.map(
        (link) => {
          return {
            id: link.id,
            link: link.link,
            name: link.name,
            type: link.type,
            expirationTime: link.expirationTime
              ? moment(link.expirationTime).format("YYYY-MM-DD")
              : moment().format("YYYY-MM-DD"),
          };
        }
      );
    },

    timePackagesLinksForBeginners() {
      this.packagesLinksForBeginners = this.timePackagesLinksForBeginners.map(
        (link) => {
          return {
            id: link.id,
            link: link.link,
            name: link.name,
            type: link.type,
            expirationTime: link.expirationTime
              ? moment(link.expirationTime).format("YYYY-MM-DD")
              : moment().format("YYYY-MM-DD"),
          };
        }
      );
    },
  },

  methods: {
    async handleRemovePackagesLinks() {
      if (this.packagesLinksToRemove && this.packagesLinksToRemove.length > 0) {
        for await (const packageLink of this.packagesLinksToRemove) {
          await this.$store.dispatch(
            "timePackagesLinks/deleteTimePackageLink",
            packageLink.id
          );
        }
        this.$store.dispatch("snackbar/showSnackbar", {
          color: "success",
          message: "Pomyślnie usunięto linki",
        });

        this.packagesLinksToRemove = [];
      }
    },

    addNextPackageLinkForGeneral() {
      this.packagesLinksForGeneral.push({
        link: "",
        name: "",
        type: "GENERAL",
        expirationTime: moment().format("YYYY-MM-DD"),
      });
    },

    removePackageLinkForGeneral(packageLink, index) {
      if (packageLink.id) {
        this.packagesLinksToRemove.push(packageLink);
      }
      this.packagesLinksForGeneral.splice(index, 1);
    },

    addNextPackageLinkForBeginners() {
      this.packagesLinksForBeginners.push({
        link: "",
        name: "",
        type: "FOR-BEGINNERS",
        expirationTime: moment().format("YYYY-MM-DD"),
      });
    },

    removePackageLinkForBeginners(packageLink, index) {
      if (packageLink.id) {
        this.packagesLinksToRemove.push(packageLink);
      }
      this.packagesLinksForBeginners.splice(index, 1);
    },

    async saveLinks() {
      let isEmptyLink = false;
      const linksArray = [
        ...this.packagesLinksForGeneral,
        ...this.packagesLinksForBeginners,
      ].map(function (item) {
        if (!item.link || !item.name) {
          isEmptyLink = true;
        }
        return item.link;
      });

      let moreThanOneSameLinks = linksArray.some(function (item, idx) {
        return linksArray.indexOf(item) != idx;
      });
      if (isEmptyLink) {
        this.$store.dispatch("snackbar/showSnackbar", {
          color: "red",
          message: "Linki oraz ich podpisy muszą być uzupełnione",
        });
        return;
      }
      if (moreThanOneSameLinks) {
        this.$store.dispatch("snackbar/showSnackbar", {
          color: "red",
          message: "Wszystkie linki muszą być unikalne",
        });
        return;
      }

      if (this.packagesLinksForGeneral) {
        for await (const packageLink of [
          ...this.packagesLinksForGeneral,
          ...this.packagesLinksForBeginners,
        ]) {
          const { id, link, name, type, expirationTime } = packageLink;
          if (!id) {
            const createdPackageLinkId = await this.$store.dispatch(
              "timePackagesLinks/createTimePackageLink",
              {
                name,
                link,
                type,
                expirationTime,
              }
            );
            packageLink.id = createdPackageLinkId;
          } else {
            await this.$store.dispatch(
              "timePackagesLinks/updateTimePackageLink",
              {
                id,
                name,
                link,
                type,
                expirationTime,
              }
            );
          }
        }

        await this.handleRemovePackagesLinks();

        this.$store.dispatch("snackbar/showSnackbar", {
          color: "success",
          message: "Pomyślnie zaktualizowano linki",
        });
      }
    },
  },
};
</script>

<style scoped>
.item-image {
  width: 130px;
  height: 130px;
  border-radius: 1rem;
  margin: 1rem;
  cursor: pointer;
  object-fit: cover;
}
.image-container {
  position: relative;
}
.slider-prev,
.slider-next {
  position: absolute;
  top: 40%;
  font-weight: lighter;
  color: #000;
  background: rgb(255, 255, 255, 0.75);
  cursor: pointer;
  border-radius: 100px;
  padding: 0 5px;
  font-size: 20px;
}
.slider-prev {
  left: 1.3rem;
}
.slider-next {
  right: 1.3rem;
}
.delete-image-icon {
  position: absolute;
  top: 1rem;
  right: 1rem;
}
</style>
